import api from './api'

const DOWNLOADS_SIGN_URL = '/downloads/sign'

export default {
  sign: function (downloadURL) {
    var url = DOWNLOADS_SIGN_URL
    var payload = { url: downloadURL }
    return api.newRequest('post', url, payload)
  }
}
